import React from "react";
import CustomArrowDown from "./ArrowDownIcon";
import {
  CustomMenuItem,
  CustomMobileSelect,
  DesktopCustomSelect
} from "./styles";

type Props = {
  options: { value: string; label: string }[];
  value: string;
  onChange?: (
    event: React.ChangeEvent<{
      name?: string;
      value: unknown;
    }>
  ) => void;
};

export default function HybridDropdown({ options, value, onChange }: Props) {
  return (
    <>
      <DesktopCustomSelect
        value={value}
        onChange={onChange}
        IconComponent={CustomArrowDown}
      >
        {options.map(option => (
          <CustomMenuItem key={option.value} value={option.value}>
            {option.label}
          </CustomMenuItem>
        ))}
      </DesktopCustomSelect>
      <CustomMobileSelect
        value={value}
        onChange={onChange}
        IconComponent={CustomArrowDown}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </CustomMobileSelect>
    </>
  );
}
